import { Add } from '@mui/icons-material';
import { Box, Grid, Button, Divider } from '@mui/material';
import { useFieldArray, useFormContext } from 'react-hook-form';
import ControlledTextField from 'src/shared/components/form/controlledTextField';
import GridWrapper from 'src/shared/components/organisms/gridWrapper';
import { useTranslation } from 'react-i18next';

export const EventParticipantFieldArray = () => {
  const { control } = useFormContext();

  const { t } = useTranslation();

  const { fields, append, remove } = useFieldArray({
    control,
    name: 'externalParticipants',
  });

  return (
    <Box sx={{ pt: 2.5 }}>
      {fields.map((item, index) => (
        <Box sx={{ mb: 2 }} key={item.id}>
          <GridWrapper narrow>
            <Grid item xs={12} md>
              <ControlledTextField name={`externalParticipants.${index}.email`} label={t('event:formFields.email')} />
            </Grid>
            <Grid item xs md='auto'>
              <ControlledTextField name={`externalParticipants.${index}.firstname`} label={t('event:formFields.firstName')} />
            </Grid>

            <Grid item xs={5} md='auto'>
              <ControlledTextField name={`externalParticipants.${index}.lastname`} label={t('event:formFields.lastName')} />
            </Grid>
            <Grid item xs md={1.5} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
              <Box width='100%'>
                <Button size='medium' fullWidth variant='contained' disableElevation onClick={() => remove(index)}>
                  {t('common:button.delete')}
                </Button>
              </Box>
            </Grid>
            {index + 1 !== fields.length && (
              <Grid item xs={12} sx={{ display: { xs: 'block', md: 'none' } }}>
                <Divider sx={{ mx: -0.5 }} />
              </Grid>
            )}
          </GridWrapper>
        </Box>
      ))}

      <GridWrapper>
        <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
          <Button size='small' variant='outlined' endIcon={<Add />} onClick={() => append({ email: '', firstname: '', lastname: '' })}>
            {t('common:button.add')}
          </Button>
        </Grid>
      </GridWrapper>
    </Box>
  );
};
